import Cookies from 'js-cookie';

const USER_INFO_KEY = 'routuan_supplier_user_info';
const USER_ID_KEY = 'routuan_supplier_user_id';

// 设置用户信息
export const setUserInfo = (userInfo: any) => {
  return Cookies.set(USER_INFO_KEY, userInfo);
}

// 移除用户信息
export const removeUserInfo = () => {
  return Cookies.remove(USER_INFO_KEY);
}

// 获取用户信息
export const getUserInfo = () => {
  const userInfo = Cookies.get(USER_INFO_KEY);
  if (typeof userInfo === 'string') {
    return JSON.parse(userInfo);
  }
  return userInfo;
}

// 设置用户id
export const setUserId = (id: number) => {
  return Cookies.set(USER_ID_KEY, id + '');
}

// 移除用户id
export const removeUserId = () => {
  return Cookies.remove(USER_ID_KEY);
}

// 获取用户id
export const getUserId = () => {
  const userId = Cookies.get(USER_ID_KEY);
  if (typeof userId === 'string') {
    return +userId;
  }
  return userId;
}